import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const RegistryChecklistIcon = ({
  title = 'RegistryChecklist',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 30 24" {...props}>
    {/* prettier-ignore */}
    <g fill="none" fillRule="nonzero"><path d="M0 0h30v30H0z"/><g fill="currentColor"><path d="M5 4.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5 6a3 3 0 110-6 3 3 0 010 6zM11.75 3.75a.75.75 0 010-1.5h15.5a.75.75 0 110 1.5h-15.5zM5 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5 15a3 3 0 110-6 3 3 0 010 6zM11.75 12.75a.75.75 0 010-1.5h15.5a.75.75 0 110 1.5h-15.5z"/><g><path d="M5 22.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM5 24a3 3 0 110-6 3 3 0 010 6zM11.75 21.75a.75.75 0 010-1.5h15.5a.75.75 0 110 1.5h-15.5z"/></g></g></g>
  </CreateIconComponent>
);

export default RegistryChecklistIcon;
